import React, { useEffect, useState } from 'react';
import { Field } from 'redux-form';
import {
    allowedExtensions,
    fetchFieldValue,
    getFormattedDateusingUrl,
    handleUploadKycImage,
    handleViewClick,
    isApproved,
    isUboTabNotEmpty,
    redClassRemarksCond,
    replaceSquareBraces,
    setInitialPiiData,
    setInitialVerifiedData,
    updateIsInvalidButton,
    VERIFIED,
} from '../mle.utils';
import { FILE_MSG, PAN } from '../mle.constants';
import { UBO_ACCORDIAN_NAME, UBO_CREATE_FORM_NAME, uboFields } from './constant';
import { FormElems } from 'components';
import { PanOcr } from 'components/PanOcr';
import Address from 'components/Address';
import MyTooltip from '../BusinessTab/MyTooltip';
import { MAX_FILE_SIZE } from 'utils/constants/commonValues';
import { toast } from 'react-toastify';
import TitleComponent from 'components/TitleComponent';

const UboInputFields = ({
    isViewMode,
    field,
    actions,
    sectionData,
    fields,
    index,
    item,
    setIsUploading,
    setSelectedDocument,
    poaOptions,
    setActiveCount,
    activeCount,
    setInvalidSubmit,
    uboFormData,
    intentId,
    checkerRemarks,
    setPanNumbers,
    panNumbers,
    isEditMode,
    infoMsgs,
    entityId,
    isReEditFlow,
    setUboAdded,
    setIntentId,
    createdAt,
    setDocTimeStamp,
    clearBtnHide = false,
    eventType
 }) => {
    
    let panFields = {
        panDate: {
            ...uboFields.panDate,
            name: uboFields.panDate.name(field)
        },
        panUpload: {
            ...uboFields.panUpload,
            name: uboFields.panUpload.name(field),
            reqname: uboFields.panUpload.reqname(field)
        },
        pan: {
            ...uboFields.pan,
            name: uboFields.pan.name(field)
        },
        panName: {
            ...uboFields.panName,
            name: uboFields.panName.name(field)
        },
        verifyPan: {
            ...uboFields.verifyPan,
            name: uboFields.verifyPan.name(field)
        }
    }
    const [isPiiVerified, setIsPiiVerified] = useState({});
    
    const [piiData, setPiiData] = useState({});
    const [pinCodeDetails, setPinCodeDetails] = useState([]);
    const [docUrls, setDocUrls] = useState({});
    const [clearClicked, setClearClicked] = useState(0);

    const isPanVerified = fetchFieldValue(uboFormData.values, panFields.verifyPan.name);

    useEffect(() => {
        
        const piiVerifiedData = setInitialVerifiedData({values: uboFormData.initial, fields: panFields, checkerRemarks, isEditMode});
        
        if (piiVerifiedData?.[PAN]?.verifiedStatus !== VERIFIED) {
            actions.change(
                UBO_CREATE_FORM_NAME,
                panFields.verifyPan.name,
                false
            );
        }
        setIsPiiVerified(piiVerifiedData);
    }, [uboFormData?.initial?.uboDetails?.[index]?.panDetails?.panNumber?.value]);

    useEffect(() => {
        const piiVerifiedData = setInitialVerifiedData({values: uboFormData.values, fields: panFields, checkerRemarks, isEditMode});
        setPiiData(setInitialPiiData({values: uboFormData.values, fields: panFields}));
        setIsPiiVerified(piiVerifiedData);
        setDocUrls(fetchFieldValue(uboFormData.values, uboFields.uploadUboPoA.reqname(field)));
    }, [uboFormData?.values?.uboDetails?.length]);
    
    useEffect(() => {

        if (activeCount[index]) {
            updateIsInvalidButton(setInvalidSubmit, field, !isPanVerified);
        } else if (!activeCount[index]) {
            updateIsInvalidButton(setInvalidSubmit, field, false);
        }
    }, [fields.length, isPanVerified]);

    useEffect(() => {
        if (piiData[PAN]?.documentDetails?.panNumber?.value) {
            setPanNumbers(prev => {
                prev[index] = piiData[PAN].documentDetails.panNumber.value;
                return prev;
            })
        }
    }, [fields.length, piiData[PAN]?.documentDetails?.panNumber?.value])
    

    

    let addressFields = {
        pin: {
            ...uboFields.uboPincode,
            name: uboFields.uboPincode.name(field)
        },
        district: {
            ...uboFields.uboDistrict,
            name: uboFields.uboDistrict.name(field)
        },
        state: {
            ...uboFields.uboState,
            name: uboFields.uboState.name(field)
        },
        address: {
            ...uboFields.uboAddress,
            name: uboFields.uboAddress.name(field)
        }
    }
    let remarkPrefix = null;
    const panList = typeof panNumbers === 'object' ? Object.values(panNumbers) : [];
    const panName = fetchFieldValue(uboFormData.values, uboFields.panName.name(field));
    const uboName = fetchFieldValue(uboFormData.values, uboFields.uboName.name(field));
    const legalInfoMsg = (panName !== uboName) ? infoMsgs?.[replaceSquareBraces(uboFields.uboName.name(field))] ?? '' : '';
    const panInfoMsg = (panName !== uboName) ? infoMsgs?.[replaceSquareBraces(uboFields.panName.name(field))] ?? '' : '';

    
    return (
        <>
            <ul className="form-list">
                <li className="form-section">
                    <div className="form-field">
                        <TitleComponent 
                            field={uboFields.uboName}
                            checkerRemarks={checkerRemarks}
                            isEditMode={isEditMode}
                            isReEditFlow={isReEditFlow}
                            infoMsgs={infoMsgs}
                            fieldName={uboFields.uboName.name(field)}
                            prefix={remarkPrefix}
                        />
                        <Field
                            name={uboFields.uboName.name(field)}
                            id={uboFields.uboName.name(field)}
                            type={uboFields.uboName.type}
                            component={FormElems.Input}
                            infoElement={legalInfoMsg}
                            placeholder={uboFields.uboName.label}
                            disabled={
                                isViewMode ||
                                isApproved(checkerRemarks, uboFields.uboName.name(field), remarkPrefix, isEditMode)
                            }
                        />
                    </div>
                    <PanOcr
                        fields = {panFields}
                        formName = {UBO_CREATE_FORM_NAME}
                        actions={actions}
                        setPiiData={setPiiData}
                        setIsUploading={setIsUploading}
                        piiData={piiData}
                        isViewMode={isViewMode}
                        setSelectedDocument={setSelectedDocument}
                        setIsPiiVerified={setIsPiiVerified}
                        isPiiVerified={isPiiVerified}
                        itemCount={1}
                        values={uboFormData?.values || {}}
                        intentId={intentId}
                        checkerRemarks={checkerRemarks}
                        clearClicked={clearClicked}
                        panNumbers={panList}
                        isEditMode={isEditMode}
                        infoMsgs={infoMsgs}
                        entityId={entityId}
                        isReEditFlow={isReEditFlow}
                        setIntentId={setIntentId}
                        panInfoMsg={panInfoMsg}
                        initialValues={uboFormData?.initial}
                        createdAt={createdAt}
                        setDocTimeStamp={setDocTimeStamp}
                        eventType={eventType}
                        isUBO={true}
                    />
                    <Address
                        fields={addressFields}
                        setIsUploading={setIsUploading}
                        setPinCodeDetails={setPinCodeDetails}
                        actions={actions}
                        formName={UBO_CREATE_FORM_NAME}
                        pinCodeDetails={pinCodeDetails}
                        isViewMode={isViewMode}
                        values={uboFormData?.values || {}}
                        checkerRemarks={checkerRemarks}
                        isEditMode={isEditMode}
                        infoMsgs={infoMsgs}
                        isReEditFlow={isReEditFlow}
                    />
                    <div className="form-field">
                        <TitleComponent 
                            field={uboFields.uboPoA}
                            checkerRemarks={checkerRemarks}
                            isEditMode={isEditMode}
                            isReEditFlow={isReEditFlow}
                            infoMsgs={infoMsgs}
                            fieldName={uboFields.uboPoA.name(field)}
                            prefix={remarkPrefix}
                        />
                        <Field
                            name={uboFields.uboPoA.name(field)}
                            id={uboFields.uboPoA.name(field)}
                            type={uboFields.uboPoA.type}
                            labelField='docName'
                            valueField='docType'
                            data={poaOptions}
                            component={FormElems.Select}
                            placeholder={uboFields.uboPoA.label}
                            disabled={
                                isViewMode ||
                                isApproved(checkerRemarks, uboFields.uboPoA.name(field), remarkPrefix, isEditMode)
                            }
                        />
                    </div>
                    <div className="form-field">
                        <TitleComponent 
                            field={uboFields.uboEmail}
                            checkerRemarks={checkerRemarks}
                            isEditMode={isEditMode}
                            isReEditFlow={isReEditFlow}
                            infoMsgs={infoMsgs}
                            fieldName={uboFields.uboEmail.name(field)}
                            prefix={remarkPrefix}
                        />
                        <Field
                            name={uboFields.uboEmail.name(field)}
                            id={uboFields.uboEmail.name(field)}
                            type={uboFields.uboEmail.type}
                            component={FormElems.Input}
                            placeholder={uboFields.uboEmail.label}
                            disabled={
                                isViewMode ||
                                isApproved(checkerRemarks, uboFields.uboEmail.name(field), remarkPrefix, isEditMode)
                            }
                        />
                    </div>
                    <div className="form-field uploadDivContainer">
                        <TitleComponent 
                            field={uboFields.uploadUboPoA}
                            checkerRemarks={checkerRemarks}
                            isEditMode={isEditMode}
                            isReEditFlow={isReEditFlow}
                            infoMsgs={infoMsgs}
                            fieldName={uboFields.uploadUboPoA.reqname(field)}
                            prefix={remarkPrefix}
                            fieldDate={getFormattedDateusingUrl(fetchFieldValue(uboFormData.values, uboFields.uploadUboPoA.reqname(field)), createdAt)}
                        />
                        <Field
                            handleChange={(name, value) => {
                                
                                setDocUrls(value);
                                if(!value){
                                    actions.change(
                                        UBO_CREATE_FORM_NAME,
                                        uboFields.uploadUboPoA.reqname(field),
                                        value
                                    );
                                }
                            }}
                            uploadImageAndGetURL={file => {
                                return handleUploadKycImage(
                                    file, 
                                    setIsUploading, 
                                    actions, 
                                    uboFields.uploadUboPoA.reqname(field), 
                                    UBO_CREATE_FORM_NAME,
                                    isEditMode || isReEditFlow,
                                    entityId,
                                    uboFields.uploadUboPoA.reqname(field)
                                );
                            }}
                            docUrl={docUrls || ''}
                            handleView={(docUrl) => handleViewClick(docUrl, setIsUploading, setSelectedDocument, setDocTimeStamp, createdAt)}
                            name={uboFields.uploadUboPoA.name(field)}
                            id={uboFields.uploadUboPoA.name(field)}
                            type={uboFields.uploadUboPoA.type}
                            component={FormElems.UploadElement}
                            placeholder={uboFields.uploadUboPoA.label}
                            disabled={
                                isViewMode ||
                                isApproved(checkerRemarks, uboFields.uploadUboPoA.reqname(field), remarkPrefix, isEditMode)
                            }
                            allowedExtensions={allowedExtensions}
                            accept={uboFields.uploadUboPoA.accept}
                            infoElement={`${FILE_MSG}${allowedExtensions.join(', ')}`}
                            labelName={"Address Proof Document"}
                            MaxFileSize={MAX_FILE_SIZE}
                        />
                    </div>
                </li>
            </ul>
            <div className="action-container">
                <div className="align-button action">
                    {(!isViewMode && !isEditMode && !clearBtnHide) && (
                        <>
                            <FormElems.Button
                                type="button"
                                buttonType="secondary"
                                id={`clear-item${index + 1}`}
                                text={`Clear UBO`}
                                customClass="remove-button"
                                handleClick={() => {
                                    actions.change(
                                        UBO_CREATE_FORM_NAME,
                                        item,
                                        undefined
                                    );
                                    setDocUrls('');
                                    setIsPiiVerified({
                                        PAN: {}
                                    })
                                    setPiiData({
                                        PAN:{}
                                    })
                                    setPinCodeDetails([])
                                    setClearClicked((prev) => prev+1)
                                }}
                            />
                            {!isUboTabNotEmpty(sectionData) && fields.length > 1 && (
                                <FormElems.Button
                                    type="button"
                                    buttonType="secondary"
                                    id={`remove-item${index + 1}`}
                                    text={`Remove UBO`}
                                    customClass="remove-button"
                                    handleClick={() => {
                                        setActiveCount([])
                                        // update pan number and verify button state
                                        setPanNumbers({})
                                        setInvalidSubmit({})
                                        setUboAdded((prev) => {
                                            let updated = prev.slice(0,-1);
                                            return updated;
                                        })
                                        fields.remove(index);
                                        toast.success("UBO removed sucessfully");
                                    }}
                                />
                            )}
                        </>
                    )}
                </div>
            </div>
        </>
    );
};

export default UboInputFields;
